module.exports = __webpack_public_path__ + "img/pin-black-diamond.1981f73b.png";